import { render, staticRenderFns } from "./MessageNotificationDropdown.vue?vue&type=template&id=8a6f24e2&scoped=true"
import script from "./MessageNotificationDropdown.vue?vue&type=script&lang=js"
export * from "./MessageNotificationDropdown.vue?vue&type=script&lang=js"
import style0 from "./MessageNotificationDropdown.vue?vue&type=style&index=0&id=8a6f24e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6f24e2",
  null
  
)

export default component.exports